<template>
    <v-container class="my-5">
        <!--     Dialog para Mostrar Codigo QR del Trabajador     -->
        <v-dialog
                v-model="dialogQR"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('qr_code')}}
                </v-card-title>
                <v-card-text>
                  <h3>{{dataWorker.first_name}} {{dataWorker.last_name}}</h3>
                  <v-flex xs12>
                    <v-img
                        class="pt-3 pb-3"
                        :src="'https://api.qrserver.com/v1/create-qr-code/?data=' + dataWorker.qr_code + '&ecc=M&margin=20&size=400x400'"
                        width="250"
                        height="250"
                    ></v-img>
                  </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="dialogQR = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Dialog para Mostrar mensaje "Seleccionar al menos un día de la Semana"       -->
        <v-dialog
                v-model="dialogAtLeastOneDay"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
                    {{$t('msg_no_days')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="dialogAtLeastOneDay = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Residentes     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_worker')}}
                </v-card-title>
                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteWorker()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
        <v-dialog v-model="dialogImageFront" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageFront"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCuttingFront()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Posterior      -->
        <v-dialog v-model="dialogImageBack" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageBack"
                            :src="imageBackURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCuttingBack()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL"
                            ref="clipperImageProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCuttingProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('workers') }}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-btn
                            color="primary"
                            dark
                            v-on="on"
                            @click="update = false,
                            cleanFields()"
                    >
                        + {{ $t('add_worker') }}
                    </v-btn>
                </template>
                <v-form
                        @submit.prevent="update
                                        ? updateWorker(id_update)
                                        : createWorker()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('worker') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-autocomplete
                                  class="mt-3 mb-3 ml-3 mr-3"
                                  v-model="idHouseWorker"
                                  prepend-icon="mdi-home-city"
                                  name="idHouseWorker"
                                  :item-text="example"
                                  item-value="id"
                                  :label="$t('casas')"
                                  :placeholder="$t('search_by_house_number')"
                                  :filter="customFilterHouse"
                                  :items="houses"
                                  no-data-text="Ningún Resultado"
                                  :error-messages="errores.idHouse"
                                  clearable
                                  outlined
                                  autocomplete="off"
                              >
                                <template v-slot:item="data">
                                  <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                                </template>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                      v-show="getProfile.enable_biometric"
                                      v-model="payroll_number"
                                      prepend-icon="mdi-numeric"
                                      name="payroll_number"
                                      :label="$t('payroll_number')"
                                      :error-messages="errores.payroll_number"
                                >
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs12 sm6>
                              <v-text-field
                                  v-model="first_name"
                                  prepend-icon="mdi-account"
                                  name="first_name"
                                  :label="$t('Nombre')"
                                  :error-messages="errores.first_name"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                              <v-text-field
                                  v-model="last_name"
                                  prepend-icon="mdi-account-outline"
                                  name="last_name"
                                  :label="$t('Apellido')"
                                  :error-messages="errores.last_name"
                              >
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                              <div class="splash-info">
                                <v-label>
                                  {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                </v-label>
                                <br>
                                <v-img
                                    class="pt-3 pb-3"
                                    :src="resultFrontURL"
                                    v-if="resultFrontURL"
                                    width="auto"
                                    height="180"
                                ></v-img>
                                <br>
                                <v-alert
                                    v-if="errores.idFront"
                                    type="error"
                                    outlined
                                    transition="scale-transition"
                                >
                                  {{errores.idFront}}
                                </v-alert>
                                <br>
                                <v-btn
                                    color="primary">
                                  <clipper-upload
                                      @input="dialog = false, dialogImageFront = true, degrees = 0, ratio = '1'"
                                      accept="image/*"
                                      v-model="imageFrontURL"
                                  >
                                    {{ update === true ? $t('update_image') : $t('subir_imagen') }}
                                  </clipper-upload>
                                </v-btn>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                              <div class="splash-info">
                                <v-label>
                                  {{$t('foto_ine')}}<br>[{{$t('reverso')}}]
                                </v-label>
                                <br>
                                <v-img
                                    class="pt-3 pb-3"
                                    :src="resultBackURL"
                                    v-if="resultBackURL"
                                    width="auto"
                                    height="180"
                                ></v-img>
                                <br>
                                <v-alert
                                    v-if="errores.idBack"
                                    type="error"
                                    outlined
                                    transition="scale-transition"
                                >
                                  {{errores.idBack}}
                                </v-alert>
                                <br>
                                <v-btn
                                    color="primary">
                                  <clipper-upload
                                      @input="dialog = false, dialogImageBack = true, degrees = 0, ratio = '1'"
                                      accept="image/*"
                                      v-model="imageBackURL"
                                  >
                                    {{ update === true ? $t('update_image') : $t('subir_imagen') }}
                                  </clipper-upload>
                                </v-btn>
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                              <div class="splash-info">
                                <v-label>
                                  {{$t('foto_perfil')}}
                                </v-label>
                                <br>
                                <div class="wrapper">
                                  <img
                                      :src="resultProfileURL"
                                      v-if="resultProfileURL">
                                </div>
                                <br>
                                <v-alert
                                    v-if="errores.avatar"
                                    type="error"
                                    outlined
                                    transition="scale-transition"
                                >
                                  {{errores.avatar}}
                                </v-alert>
                                <br>
                                <v-btn
                                    color="primary">
                                  <clipper-upload
                                      @input="dialog = false, dialogImageProfile = true, degrees = 0, ratio = '1'"
                                      accept="image/*"
                                      v-model="imageProfileURL"
                                  >
                                    {{ update === true ? $t('update_image') : $t('subir_imagen') }}
                                  </clipper-upload>
                                </v-btn>
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs12 sm6>
                              <v-label>{{ $t('access_days') }}</v-label>
                              <v-container fluid>
                                <v-layout row>
                                  <v-checkbox
                                      color="primary"
                                      v-model="Monday"
                                      :label="$t('Lunes')"
                                      hide-details
                                  ></v-checkbox>
                                  <v-checkbox
                                      color="primary"
                                      v-model="Tuesday"
                                      :label="$t('Martes')"
                                      hide-details
                                  ></v-checkbox>
                                  <v-checkbox
                                      color="primary"
                                      v-model="Wednesday"
                                      :label="$t('Miercoles')"
                                      hide-details
                                  ></v-checkbox>
                                </v-layout>
                                <v-layout row>
                                  <v-checkbox
                                      color="primary"
                                      v-model="Thursday"
                                      :label="$t('Jueves')"
                                      hide-details
                                  ></v-checkbox>
                                  <v-checkbox
                                      color="primary"
                                      v-model="Friday"
                                      :label="$t('Viernes')"
                                      hide-details
                                  ></v-checkbox>
                                  <v-checkbox
                                      color="primary"
                                      v-model="Saturday"
                                      :label="$t('Sabado')"
                                      hide-details
                                  ></v-checkbox>
                                </v-layout>
                                <v-layout row>
                                  <v-checkbox
                                      color="primary"
                                      v-model="Sunday"
                                      :label="$t('Domingo')"
                                      hide-details
                                  ></v-checkbox>
                                </v-layout>
                              </v-container>
                            </v-flex>
                            <v-flex xs12 sm6>
                              <v-container fluid>
                                <v-layout row wrap>
                                  <v-flex sm6>
                                  <v-menu
                                      v-model="menuCalendar"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      max-width="290px"
                                      min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                          v-model="computedDateFormatted"
                                          :label="$t('fecha_inicial')"
                                          hint="DD/MM/YYYY"
                                          persistent-hint
                                          prepend-icon="mdi-calendar"
                                          :error-messages="errores.dateInv"
                                          readonly
                                          v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="date"
                                        no-title
                                        :min="getCurrentDate()"
                                        :locale="$t('region')"
                                        @input="menuCalendar = false"
                                    ></v-date-picker>
                                  </v-menu>
                                  </v-flex>
                                  <v-flex sm6>
                                  <v-menu
                                      v-model="menuCalendarExpiration"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      max-width="290px"
                                      min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                          v-model="computedDateExpirationFormatted"
                                          :label="$t('fecha_expiracion')"
                                          hint="DD/MM/YYYY"
                                          persistent-hint
                                          prepend-icon="mdi-calendar"
                                          :error-messages="errores.expiration"
                                          readonly
                                          v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dateExpiration"
                                        no-title
                                        :min="getCurrentDate()"
                                        :locale="$t('region')"
                                        @input="menuCalendarExpiration = false"
                                    ></v-date-picker>
                                  </v-menu>
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                  <v-flex xs12 sm6>
                                  <v-menu
                                      ref="menuCheckInTime"
                                      v-model="menuCheckInTime"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      :return-value.sync="checkInTime"
                                      transition="scale-transition"
                                      offset-y
                                      max-width="290px"
                                      min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                          v-model="checkInTime"
                                          :label="$t('check_in_time')"
                                          prepend-icon="mdi-clock"
                                          :error-messages="errores.check_in_time"
                                          readonly
                                          v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-if="menuCheckInTime"
                                        v-model="checkInTime"
                                        scrollable
                                        format="24hr"
                                        @click:minute="$refs.menuCheckInTime.save(checkInTime)"
                                    ></v-time-picker>
                                  </v-menu>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                  <v-menu
                                      ref="menuCheckOutTime"
                                      v-model="menuCheckOutTime"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      :return-value.sync="checkOutTime"
                                      transition="scale-transition"
                                      offset-y
                                      max-width="290px"
                                      min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                          v-model="checkOutTime"
                                          :label="$t('check_out_time')"
                                          prepend-icon="mdi-clock"
                                          :error-messages="errores.check_out_time"
                                          readonly
                                          v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-if="menuCheckOutTime"
                                        v-model="checkOutTime"
                                        scrollable
                                        format="24hr"
                                        @click:minute="$refs.menuCheckOutTime.save(checkOutTime)"
                                    ></v-time-picker>
                                  </v-menu>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-flex>
                          </v-layout>
                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    transition="scale-transition"
                            >
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="clear(),
                                    dialog = false"
                            >{{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    v-if="update"
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                            >{{$t('modificar')}}
                            </v-btn>
                            <v-btn
                                    v-else
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                            >{{$t('agregar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
          <v-flex>
            <v-card class="elevation-5">
              <v-toolbar dark color="primary">
                <v-toolbar-title>
                  {{$t('workers')}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-layout row wrap class="my-4" align-center justify-center fill-height>
                  <v-flex xs8>
                    <v-card-title class="justify-center">
                      <v-text-field
                          outlined
                          clearable
                          v-model="search"
                          append-icon="mdi-magnify"
                          :label="$t('Buscar')"
                          :placeholder="$t('Buscar')"
                      ></v-text-field>
                    </v-card-title>
                  </v-flex>
                  <v-flex xs4>
                    <v-card-title class="justify-center">
                      <v-autocomplete
                          v-model="idHouse"
                          prepend-icon="mdi-home-city"
                          name="idHouse"
                          :item-text="example"
                          item-value="id"
                          :label="$t('casas')"
                          :placeholder="$t('search_by_house_number')"
                          :filter="customFilterHouse"
                          :items="houses"
                          no-data-text="Ningún Resultado"
                          clearable
                          outlined
                          autocomplete="off"
                      >
                        <template v-slot:item="data">
                          <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                        </template>
                      </v-autocomplete>
                    </v-card-title>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn
                        v-show="selected.length > 0"
                        color="green"
                        block
                        :loading="loadingSendPrint"
                        @click="sendPrint"
                    >
                      {{$t('display_info_print')}} ({{selected.length}})
                    </v-btn>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs12>
                    <v-data-table
                        v-model="selected"
                        show-select
                        item-key="id"
                        :headers="getProfile.enable_biometric === true ? headers : headers2"
                        :loading="loadingWorkers"
                        :items="workers"
                        :search="search"
                        :footer-props="{
                            itemsPerPageOptions: [
                                {text: '12', value: 12},
                                {text: '24', value: 24},
                                {text: '48', value: 48},
                                {text: this.$t('todos'), value: -1}
                            ],
                            itemsPerPageText: $t('filas_por_pagina')
                        }"
                        :no-data-text="$t('no_records_yet')"
                        class="elevation-1"
                    >
                    <template v-slot:items="props">
                        <td>{{ props.item.id }}</td>
                        <td>{{ props.item.id_usuario.first_name }}</td>
                        <td>{{ props.item.id_usuario.last_name }}</td>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="gray"
                                        class="mr-2"
                                        @click="fillFields(item), update = true, dialog = true, id_update = item.id"
                                >
                                    mdi-account-edit
                                </v-icon>
                            </template>
                            <span>{{$t('show_details')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="red"
                                        class="mr-2"
                                        @click="deleteDialog = true, idWorkerDelete = item.id"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>{{$t('delete')}}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:no-results>
                        <v-alert type="warning">
                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                        </v-alert>
                    </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { mapState, mapGetters } from 'vuex'
import Vue from 'vue'

Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'workers_admin',
  created: function () {
    this.getHouses()
    this.getWorkers()
  },
  data: () => ({
    show: false,
    alerta: false,
    dialog: false,
    dialogQR: false,
    dataWorker: {},
    update: false,
    id_update: 0,
    first_name: '',
    last_name: '',
    first_name_aux: '',
    last_name_aux: '',
    headers: [],
    headers2: [],
    workers: [],
    loadingWorkers: false,
    loading: false,
    search: '',
    // Imágenes
    dialogImageProfile: false,
    imageProfileURL: '',
    resultProfileURL: '',
    resultAuxProfileURL: '',
    dialogImageFront: false,
    imageFrontURL: '',
    resultFrontURL: '',
    resultAuxFrontURL: '',
    dialogImageBack: false,
    imageBackURL: '',
    resultBackURL: '',
    resultAuxBackURL: '',
    // Delete Guard
    deleteDialog: false,
    idWorkerDelete: 0,
    // Guest Data
    dialogGuest: false,
    bandGuest: false,
    degrees: 0,
    ratio: '1',
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,
    days: '',
    days_aux: '',
    dialogAtLeastOneDay: false,
    errores: [],
    menuCalendar: false,
    menuCalendarExpiration: false,
    checkInTime: '',
    checkInTime_aux: '',
    menuCheckInTime: '',
    checkOutTime: '',
    checkOutTime_aux: '',
    menuCheckOutTime: '',
    date: '',
    date_aux: '',
    dateExpiration: '',
    idHouse: null,
    idHouseWorker: null,
    idHouseWorker_aux: null,
    payroll_number: '',
    houses: [],
    loadingSendPrint: false,
    workersAdminBase64: [],
    selected: [],
    dateExpiration_aux: ''
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('payroll_number'),
        align: 'left',
        sortable: true,
        value: 'payroll_number'
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'last_name'
      },
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'address'
      },
      {
        text: 'ID',
        align: 'center',
        sortable: false,
        value: 'idHouse',
        filter: this.idHouseFilter
      }
    ]
    this.headers2 = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'last_name'
      },
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'address'
      },
      {
        text: 'ID',
        align: 'center',
        sortable: false,
        value: 'idHouse',
        filter: this.idHouseFilter
      }
    ]
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    computedDateExpirationFormatted () {
      return this.formatDate(this.dateExpiration)
    },
    ...mapState(['language']),
    ...mapGetters(['getProfile'])
  },
  methods: {
    getHouses: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.houses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    example: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number),
    customFilterHouse (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    /**
     * Filter for calories column.
     * @param value Value to be tested.
     * @returns {boolean}
     */
    idHouseFilter (value) {
      // If this filter has no value we just skip the entire filter.
      if (this.idHouse === null || this.idHouse === undefined) {
        return true
      }
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value.toLowerCase().includes(this.idHouse.toLowerCase())
    },
    getCurrentDate () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = yyyy + '-' + mm + '-' + dd
      return today
    },
    timeNow () {
      var d = new Date()
      var h = (d.getHours() < 10 ? '0' : '') + d.getHours()
      var m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
      this.checkInTime = h + ':' + m
      this.checkOutTime = h + ':' + m
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    getDays () {
      this.days = ''

      if (this.Monday) {
        this.days = '0'
      }
      if (this.Tuesday) {
        this.days += '1'
      }
      if (this.Wednesday) {
        this.days += '2'
      }
      if (this.Thursday) {
        this.days += '3'
      }
      if (this.Friday) {
        this.days += '4'
      }
      if (this.Saturday) {
        this.days += '5'
      }
      if (this.Sunday) {
        this.days += '6'
      }
    },
    AtLeastOneDay () {
      var count = 0

      if (this.Monday) {
        count++
      }
      if (this.Tuesday) {
        count++
      }
      if (this.Wednesday) {
        count++
      }
      if (this.Thursday) {
        count++
      }
      if (this.Friday) {
        count++
      }
      if (this.Saturday) {
        count++
      }
      if (this.Sunday) {
        count++
      }
      return count
    },
    getWorkers: function () {
      this.loadingWorkers = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/worker_admin/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.workers = response.data
          this.loadingWorkers = false
        })
        .catch(error => {
          this.loadingWorkers = false
          console.log(error)
        })
    },
    getAdminBase64Workers (records) {
      this.loadingSendPrint = true
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/worker_admin/base64/list',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        data: records
      }
      axios(config)
        .then(response => {
          this.loadingSendPrint = false
          this.workersAdminBase64 = response.data
          localStorage.setItem('listPrint', JSON.stringify(this.workersAdminBase64))
          window.open('/print', 'Print')
        })
        .catch(error => {
          this.loadingSendPrint = false
          console.log(error)
        })
    },
    createWorker: function () {
      // console.log(this.checkInTime)
      // console.log(this.checkOutTime)
      // console.log(this.date)
      // console.log(this.dateExpiration)
      if (this.AtLeastOneDay() === 0) {
        this.dialogAtLeastOneDay = true
      } else {
        this.errores = []
        this.loading = true
        var bodyFormData = new FormData()
        var fileImageProfile = null
        var fileImageFront = null
        var fileImageBack = null
        var weekdays = ''

        this.getDays()
        weekdays = this.days
        bodyFormData.set('first_name', this.first_name)
        bodyFormData.set('last_name', this.last_name)
        bodyFormData.set('payroll_number', this.payroll_number)
        bodyFormData.set('check_in_time', this.checkInTime)
        bodyFormData.set('check_out_time', this.checkOutTime)
        bodyFormData.set('initial_date', this.date)
        bodyFormData.set('final_date', this.dateExpiration)
        bodyFormData.set('diary', weekdays)
        bodyFormData.set('idHouse', this.idHouseWorker)
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          const newID = this.$uuid.v4()
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
        }
        bodyFormData.append('avatar', fileImageProfile)
        if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
          const newID = this.$uuid.v4()
          fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front' + newID + '.jpeg')
        }
        bodyFormData.append('idFront', fileImageFront)
        if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
          const newID = this.$uuid.v4()
          fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back' + newID + '.jpeg')
        }
        bodyFormData.append('idBack', fileImageBack)
        const config = {
          method: 'post',
          url: 'https://residencial-services.intrare.app/worker_admin_post/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.getWorkers()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('msg_worker_added'))
            this.dialog = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
            }
          })
      }
    },
    updateWorker: function (id) {
      // console.log(this.checkInTime_aux)
      // console.log(this.checkOutTime_aux)
      // console.log(this.date_aux)
      // console.log(this.dateExpiration_aux)
      if (this.AtLeastOneDay() === 0) {
        this.dialogAtLeastOneDay = true
      } else {
        this.errores = []
        this.loading = true
        var bodyFormData = new FormData()
        var fileImageProfile = null
        var fileImageFront = null
        var fileImageBack = null
        var weekdays = ''

        if (this.idHouseWorker !== this.idHouseWorker_aux) {
          bodyFormData.set('idHouse', this.idHouseWorker)
        }
        this.getDays()
        weekdays = this.days
        if (this.first_name_aux !== this.first_name) {
          bodyFormData.set('first_name', this.first_name)
        }
        if (this.last_name_aux !== this.last_name) {
          bodyFormData.set('last_name', this.last_name)
        }
        if (this.days_aux !== weekdays) {
          bodyFormData.set('diary', weekdays)
        }
        if (this.date_aux !== this.date) {
          bodyFormData.set('initial_date', this.date)
        }
        if (this.dateExpiration_aux !== this.dateExpiration) {
          bodyFormData.set('final_date', this.dateExpiration)
        }
        if (this.checkInTime_aux !== this.checkInTime) {
          bodyFormData.set('check_in_time', this.checkInTime)
        }
        if (this.checkOutTime_aux !== this.checkOutTime) {
          bodyFormData.set('check_out_time', this.checkOutTime)
        }
        if (this.resultProfileURL !== this.resultAuxProfileURL) {
          const newID = this.$uuid.v4()
          if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
            fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
          }
          bodyFormData.append('avatar', fileImageProfile)
        }
        if (this.resultFrontURL !== this.resultAuxFrontURL) {
          const newID = this.$uuid.v4()
          if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
            fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front' + newID + '.jpeg')
          }
          bodyFormData.append('idFront', fileImageFront)
        }
        if (this.resultBackURL !== this.resultAuxBackURL) {
          const newID = this.$uuid.v4()
          if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
            fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back' + newID + '.jpeg')
          }
          bodyFormData.append('idBack', fileImageBack)
        }
        bodyFormData.set('payroll_number', this.payroll_number)
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/worker_admin_post/' + id + '/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.getWorkers()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('msg_worker_update'))
            this.dialog = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            console.log(error.response.data)
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
            }
          })
      }
    },
    deleteWorker () {
      const config = {
        method: 'delete',
        url: ' https://residencial-services.intrare.app/worker_admin_post/' + this.idWorkerDelete + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Worker con ID = ', this.idWorkerDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_worker_deleted'))
        this.getWorkers()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    xOffset: function (pdf, text) {
      return (
        pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2)
    },
    getImgFromUrl (logoUrl, callback) {
      var img = new Image()

      img.src = logoUrl
      img.onload = function () {
        callback(img)
      }
    },
    async sendPrint () {
      console.log(this.selected)
      let records = []
      for (let i = 0; i < this.selected.length; i++) {
        let aux = this.selected[i].id
        records.push(
          aux
        )
      }
      console.log(records)
      await this.getAdminBase64Workers(records)
    },
    clear: function () {
      this.alerta = false
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    fillDays (days) {
      this.Monday = false
      this.Tuesday = false
      this.Wednesday = false
      this.Thursday = false
      this.Friday = false
      this.Saturday = false
      this.Sunday = false
      if (days.length > 0) {
        if (days.includes('0') === true) {
          this.Monday = true
        }
        if (days.includes('1') === true) {
          this.Tuesday = true
        }
        if (days.includes('2') === true) {
          this.Wednesday = true
        }
        if (days.includes('3') === true) {
          this.Thursday = true
        }
        if (days.includes('4') === true) {
          this.Friday = true
        }
        if (days.includes('5') === true) {
          this.Saturday = true
        }
        if (days.includes('6') === true) {
          this.Sunday = true
        }
      } else {
        this.Monday = false
        this.Tuesday = false
        this.Wednesday = false
        this.Thursday = false
        this.Friday = false
        this.Saturday = false
        this.Sunday = false
      }
    },
    fillFields (item) {
      this.idHouseWorker = item.idHouse
      this.idHouseWorker_aux = item.idHouse
      this.first_name = item.first_name
      this.first_name_aux = item.first_name
      this.last_name = item.last_name
      this.last_name_aux = item.last_name
      if (item.payroll_number === null) {
        this.payroll_number = ''
      } else {
        this.payroll_number = item.payroll_number
      }
      this.fillDays(item.diary)
      this.days_aux = item.diary
      this.checkInTime = item.check_in_time
      this.checkInTime_aux = item.check_in_time
      this.checkOutTime = item.check_out_time
      this.checkOutTime_aux = item.check_out_time
      this.date = item.initial_date
      this.date_aux = item.initial_date
      this.dateExpiration = item.final_date
      this.dateExpiration_aux = item.final_date
      this.resultProfileURL = item.avatar
      this.resultAuxProfileURL = item.avatar
      this.resultFrontURL = item.idFront
      this.resultAuxFrontURL = item.idFront
      this.resultBackURL = item.idBack
      this.resultAuxBackURL = item.idBack
    },
    customFilter (item, queryText) {
      const textOne = item.street.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    cleanFields () {
      this.idHouseWorker = null
      this.idHouseWorker_aux = null
      this.timeNow()
      this.date = new Date().toISOString().substr(0, 10)
      this.dateExpiration = new Date().toISOString().substr(0, 10)
      this.first_name = ''
      this.first_name_aux = ''
      this.last_name = ''
      this.last_name_aux = ''
      this.payroll_number = ''
      this.Monday = false
      this.Tuesday = false
      this.Wednesday = false
      this.Thursday = false
      this.Friday = false
      this.Saturday = false
      this.Sunday = false
      this.resultProfileURL = ''
      this.resultFrontURL = ''
      this.resultBackURL = ''
    },
    getCuttingProfile () {
      const canvas = this.$refs.clipperImageProfile.clip() // call component's clip method
      this.resultProfileURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultProfileURL)
      this.dialogImageProfile = false
      if (this.bandGuest === true) {
        this.dialogGuest = true
      } else {
        this.dialog = true
      }
    },
    getCuttingFront () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageFront.clip() // call component's clip method
      this.resultFrontURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultFrontURL)
      this.dialogImageFront = false
      this.dialog = true
    },
    getCuttingBack () {
      console.log('Datos de la imagen = ', this.imageBackURL.size)
      const canvas = this.$refs.clipperImageBack.clip() // call component's clip method
      this.resultBackURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultBackURL)
      this.dialogImageBack = false
      this.dialog = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #81c81b #81c81b #81c81b #81c81b;
        border-width: 3px 3px 3px 3px;
        text-align: center;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #81c81b;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
</style>
